export default "__VITE_ASSET__C57yW7Xk__"